import React from 'react';
import './App.css';

/**
 * Catches a crash in a screen and shows an error page over the whole window:
 * the top bar, sidebar and floating buttons of a broken screen are hidden
 * too. "Back" returns to the previous page and clears the error; "Reload"
 * reloads the page.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, message: '' };
        this.onPopState = this.onPopState.bind(this);
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, message: error && error.message ? String(error.message) : '' };
    }

    componentDidCatch(error, info) {
        // You can also log the error to an error reporting service
        //logErrorToMyService(error, info);
        console.error('ErrorBoundary', error, info);
    }

    componentDidMount() {
        window.addEventListener('popstate', this.onPopState);
    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.onPopState);
    }

    // Back in the browser (or the button below): try the previous page again.
    onPopState() {
        if (this.state.hasError) {
            this.setState({ hasError: false, message: '' });
        }
    }

    render() {
        if (!this.state.hasError) {
            return this.props.children;
        }
        const dark = this.props.theme === 'dark';
        const button = {
            padding: '10px 18px', borderRadius: 6, fontSize: 15, cursor: 'pointer', fontFamily: 'inherit',
            border: '1px solid ' + (dark ? '#4B5563' : '#C9D1DA'), background: 'transparent', color: dark ? '#E5E7EB' : '#1F2937',
        };
        return (
            <div role="alert" style={{
                position: 'fixed', inset: 0, zIndex: 3000, overflowY: 'auto',
                display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
                backgroundColor: dark ? '#232B38' : '#f2f3f5', color: dark ? '#E5E7EB' : '#1F2937',
            }}>
                <div className="errorbox" style={{ maxWidth: 560, width: '100%', textAlign: 'center' }}>
                    <h1>ERROR</h1>
                    <br/>
                    <h2>Er is iets misgelopen!</h2>
                    <p>Probeer de pagina te heropenen.</p>
                    <br/>
                    <h2>Something went wrong!</h2>
                    <p>Try to open the page again.</p>
                    <br/>
                    <h2>Il y a un erreur!</h2>
                    <p>Essayez de rouvrir la page.</p>
                    <br/>
                    <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
                        <button type="button" style={button} onClick={() => window.history.back()}>
                            ← Terug · Back · Retour
                        </button>
                        <button type="button" style={{ ...button, background: '#0071BB', borderColor: '#0071BB', color: '#fff' }} onClick={() => window.location.reload()}>
                            Opnieuw laden · Reload · Recharger
                        </button>
                    </div>
                    {this.state.message && (
                        <details style={{ marginTop: 24, fontSize: 12.5, opacity: 0.75, textAlign: 'left' }}>
                            <summary style={{ cursor: 'pointer' }}>Details</summary>
                            <code style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{this.state.message}</code>
                        </details>
                    )}
                </div>
            </div>
        );
    }
}

export default ErrorBoundary;
